<template>
  <div
    id="content"
    :data-elbglobals="elbGlobals"
    data-elbcontext="shopping:discover"
  >
    <AppBanner />
    <AlertBanner
      v-if="!pageIsVisible"
      :text="translate('alert_message_preview_mode')"
    />
    <UspBar />
    <TheCustomerMetaNavigation />
    <TheHeader />
    <main id="page-template">
      <TheCategoryTemplate />
    </main>
    <LazyComponent id="footer" :delay="2000">
      <TheFooter />
    </LazyComponent>
  </div>
</template>

<script>
import TheCustomerMetaNavigation from '@/components/basic/atoms/TheCustomerMetaNavigation.vue'
import UspBar from '@/components/basic/atoms/UspBar.vue'
import TheHeader from '@/components/basic/organisms/TheHeader.vue'
import TheCategoryTemplate from '@/components/category/templates/TheCategoryTemplate.vue'
import {
  pushWalkerEvent,
  sanitizeSearchTermForTracking
} from '@/services/helpers/ElbwalkerHelper'
import {
  containsPrivateInfo,
  NO_INDEX_FOLLOW
} from '@/services/helpers/MetaHelper.js'
import { useSearchConfig } from '@/stores/searchConfig'
import { mapActions, mapState } from 'pinia'
import { defineAsyncComponent } from 'vue'

const LazyComponent = defineAsyncComponent(
  () => import('@/components/basic/atoms/LazyComponent.vue')
)
const AppBanner = defineAsyncComponent(
  () => import('@/components/basic/molecules/AppBanner.vue')
)
const AlertBanner = defineAsyncComponent(
  () => import('@/components/basic/atoms/AlertBanner.vue')
)
const TheFooter = defineAsyncComponent(
  () => import('@/components/basic/organisms/TheFooter.vue')
)

const NAME = 'TheCategoryPage'

export default {
  head() {
    return {
      title: this.title,
      meta: [
        {
          name: 'robots',
          content: containsPrivateInfo()
            ? NO_INDEX_FOLLOW
            : this.category.robots
        },
        { name: 'description', content: this.category.meta_description }
      ]
    }
  },
  name: NAME,
  components: {
    TheCustomerMetaNavigation,
    AppBanner,
    AlertBanner,
    TheHeader,
    TheCategoryTemplate,
    LazyComponent,
    TheFooter,
    UspBar
  },
  computed: {
    ...mapState(useSearchConfig, ['category', 'getConfig']),
    footer() {
      return TheFooter
    },
    title() {
      return this.translate('search_page_title', this.searchTerm)
    },
    pageIsVisible() {
      return this.category.is_enabled
    },
    searchTerm() {
      return this.getConfig.query?.original
    },
    q() {
      return this.$route.query.q
    },
    elbGlobals() {
      const base = 'page_type:search;search_version:legacy'
      const term = sanitizeSearchTermForTracking(this.q)
      return term ? `${base};search_term:${term}` : base
    }
  },
  methods: {
    ...mapActions(useSearchConfig, ['fetchCategory']),
    trackSearchResults() {
      // category.code is only set after a search that rendered results (incl.
      // zero hits) — it stays empty on errors and redirects.
      if (!this.q || this.getConfig.error || !this.category.code) return
      pushWalkerEvent('search results', {
        total_count: this.getConfig.totalCount ?? 0
      })
    }
  },
  async created() {
    await this.fetchCategory()
    this.trackSearchResults()
  },
  watch: {
    async q() {
      await this.fetchCategory()
      this.trackSearchResults()
    }
  }
}
</script>
